<template>
  <div class="contact-wrap" :class="item.css_class">
    <button class="contact-button"
      @click="showContact = true"
    >
      <!-- {{ $t('newblock.videoOverlay.contact.heading') }}
      <span><img :src="$images.sendIcon" alt="sendIcon.png"></span> -->
    </button>
    <Modal
      v-if="showContact"
      @close-modal="showContact = false"
    >
      <ContactForm 
        :user="user"
        :item="item"
        @send-info="sendInfo"
        @close-modal="showContact = false"
      />
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/admin/Modal.vue"
import ContactForm from "./ContactForm.vue"
import api from "@/api"
export default {
  components: {
    Modal,
    ContactForm,
  },
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
      user: {},
      showContact: false,
    };
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      await this.getUserInfo();
    },
    async getUserInfo () {
      try {
        const res = await api.getProfile();
        this.user = res.data.user;
      } catch (error) {
        console.warn(error);
      }
    },
    async sendInfo (params) {
      try {
        await api.sendContactInformation(params);
        this.EventBus.$emit('info', {
          message: this.$t('newblock.videoOverlay.contact.success'),
        });
        this.showContact = false;
      } catch (error) {
        console.warn(error);
      }
    },
  },
}
</script>

<style scoped>
.contact-wrap {
	height: 100%;
	width: 100%;
}
.contact-button {
	height: 100%;
	width: 100%;
	font-family: 'Roboto';
	font-size: 16px;
	font-weight: 500;
	color: white;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: .6em;
	padding: 20px 5px;
	border-radius: 5px;
	border: none;
	cursor: pointer;
	outline: none;
	background-color: transparent;
  opacity: .6;
	font-weight: 600;
}
</style>